import React, { useState } from 'react';
import { Sun, Moon, Award, Brain, Menu, X } from 'lucide-react';
import ProfileSwitcher from '../profiles/ProfileSwitcher';
import DifficultyBadge from '../difficulty/DifficultyBadge';
import QuizModeBadge from '../quiz/QuizModeBadge';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '../../contexts/LanguageContext';

const Header = ({ 
  isDarkMode, 
  toggleTheme, 
  earnedBadges, 
  currentProfile,
  onProfileChange,
  onLogout,
  onManageProfiles,
  currentDifficulty,
  onOpenDifficultyModal,
  currentQuizMode,
  onOpenQuizModeModal
}) => {
  const { t } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  
  return (
    <header className="header">
      <h1>
        <Brain className="animate-pulse" />
        <span className="app-title-text">{t('appTitle')}</span>
      </h1>
      
      <button 
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      <div className={`header-controls ${menuOpen ? 'menu-open' : ''}`}>
        <LanguageSelector />
        
        {currentProfile && (
          <ProfileSwitcher
            currentProfile={currentProfile}
            onProfileChange={onProfileChange}
            onLogout={onLogout}
            onManageProfiles={onManageProfiles}
          />
        )}

        {currentDifficulty && onOpenDifficultyModal && (
          <DifficultyBadge
            difficulty={currentDifficulty}
            onClick={onOpenDifficultyModal}
            showLabel={true}
          />
        )}

        {currentQuizMode && onOpenQuizModeModal && (
          <QuizModeBadge
            mode={currentQuizMode}
            onClick={onOpenQuizModeModal}
            showLabel={true}
          />
        )}
        
        <div className="badge-count animate-fadeIn">
          <Award size={20} />
          <span className="badge-text">{earnedBadges.length} {t('dashboard.badgesEarned')}</span>
        </div>
        
        <button 
          className="theme-toggle hover-scale" 
          onClick={toggleTheme}
          aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>
    </header>
  );
};

export default Header;